import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalConfirmExitConfig } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

export const preInterviewModalConfirmExitConfig = (isDirty: boolean): ModalConfirmExitConfig => ({
   enabled: isDirty,
   cancelButtonLabel: commonTranslationKeys.cancel,
   confirmationButtonLabel: appointmentsTranslationKeys.preInterview.modalConfirmExit.confirm,
   content: (
      <Trans
         i18nKey={appointmentsTranslationKeys.preInterview.modalConfirmExit.content}
         components={{ bold: <strong /> }}
      />
   ),
});
